import React, { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { store } from "../redux/configStore";
import { getUserData } from "../redux/Login/Login";

/**
 * For /login, /loadata: if already logged in (cookie valid) redirect to /.
 * user_token is HttpOnly — check via GET /detail-user.
 * SSO: /loadata?user_token=xxx — skip getUserData, render LoadDatabase directly.
 */
export default function PrivativeCheckLogin() {
  const location = useLocation();
  const isSso = location.pathname === "/loadata" && new URLSearchParams(location.search).get("user_token");
  const [status, setStatus] = useState(isSso ? "guest" : "pending"); // pending | loggedIn | guest

  useEffect(() => {
    if (isSso) {
      setStatus("guest");
      return;
    }
    // Trang login: không gọi detail-user để tránh lộ API và 401 không cần thiết
    if (location.pathname === "/login") {
      setStatus("guest");
      return;
    }

    let cancelled = false;
    store.dispatch(getUserData())
      .then((action) => {
        if (cancelled) return;
        setStatus(getUserData.fulfilled.match(action) ? "loggedIn" : "guest");
      })
      .catch(() => {
        if (!cancelled) setStatus("guest");
      });
    return () => { cancelled = true; };
  }, [isSso, location.pathname, location.search]); // eslint-disable-line react-hooks/exhaustive-deps

  if (status === "loggedIn") return <Navigate to="/" replace />;
  return <Outlet />;
}
